<template>
  <footer class="gj-footer" :style="{ minHeight:height }">
    <slot></slot>
  </footer>
</template>
<script>
export default {
  name: 'GjFooter',
  componentName: 'GjFooter',
  props: {
    height: {
      type: String,
      default: '60px'
    }
  }
};

</script>



// WEBPACK FOOTER //
// src/components/footer/src/main.vue